import { EditorConfig, NodeKey, TextNode } from 'lexical';

export interface PrefixOption {
  prefix: string;
  description: string;
  dataType: 'text' | 'field' | 'user' | 'date' | 'contact-field';
  aliases?: string[];
}

export class PrefixNode extends TextNode {
  static nodeType = 'search-prefix';

  static findPrefixOption(prefix: string, options: PrefixOption[]): PrefixOption | undefined {
    const stripped = prefix[prefix.length - 1] === ':' ? prefix.substring(0, prefix.length - 1) : prefix;
    return options.find((o) => o.prefix === stripped || o.aliases?.includes(stripped));
  }

  constructor(text: string = '', key: NodeKey = null) {
    super(text, key);
  }

  $config() {
    return this.config(PrefixNode.nodeType, {
      extends: TextNode,
      // This defines the serialization of the color NodeState as
      // a flat property of the SerializedLexicalNode JSON instead of
      // nesting it in the '$' property
      // stateConfigs: [{flat: true, stateConfig: colorState}],
    });
  }

  createDOM(config: EditorConfig): HTMLElement {
    const element = super.createDOM(config);
    // element.style.color = $getState(this, colorState);
    element.classList.add(PrefixNode.nodeType);
    return element;
  }

  setTextContent(text: string) {
    return super.setTextContent(text.toLowerCase());
  }

  // updateDOM(prevNode: this, dom: HTMLElement, config: EditorConfig): boolean {
  //   if (super.updateDOM(prevNode, dom, config)) {
  //     return true;
  //   }
  //   const colorChange = $getStateChange(this, prevNode, colorState);
  //   if (colorChange !== null) {
  //     dom.style.color = colorChange[0];
  //   }
  //   return false;
  // }
}
